import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { getLanguage } from "../Managers/dataProvider";
import { EmployeeReportModel } from "../Managers/dataStructures";
import { Table, TH, TD, TR } from "../../../AuxComponents/";
import { getCurrentCurrency } from "../Managers/profileManager";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
  },
  header: {
    backgroundColor: "#FFFFFF",
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
  },
  table: {
    marginTop: "25px",
  },
  tableHeader: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
    marginLeft: "5px",
  },
  tableCell: {
    fontWeight: "500",
    fontSize: "12px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
    marginLeft: "5px",
  },
});

interface PDFReportAllEmployeesProps {
  startDateString: string;
  endDateString: string;
  array_reports: EmployeeReportModel[];
  total_hours: string;
  total_salary: string;
}

export default function PDFReportAllEmployees(
  props: PDFReportAllEmployeesProps
) {
  const isEnglish = getLanguage();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <View>
            <View>
              <Text style={styles.title}>
                {isEnglish ? "Report : All Branches" : ""}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "From : " : "Von : ") + props.startDateString}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "To : " : "Bis : ") + props.endDateString}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "Total hours: " : "Gesamtarbeitsstunden: ") +
                  props.total_hours}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "Total salary: " : "Gesamt Verdienst: ") +
                  props.total_salary}
              </Text>
            </View>
            <View></View>
            <View style={styles.table}>
              <Table>
                <TH>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Employee ID" : "Employee ID"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Name" : "Name"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Total Hours" : "Gesamtarbeitsstunden"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Salary" : "Gesamt Verdienst"}
                    </Text>
                  </TD>
                </TH>
                {props.array_reports.map((x) => CellReportDetail(x))}
              </Table>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

function CellReportDetail(item: EmployeeReportModel) {
  return (
    <TR key={item.user.user_id}>
      <TD>
        <Text style={styles.tableCell}>
          {" "}
          {item.user.employee_id !== null
            ? item.user.employee_id
            : "Not Assigned"}
        </Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>
          {item.user.first_name + " " + item.user.last_name}
        </Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>{item.working_hours}</Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>
          {getCurrentCurrency() + " " + item.total_earning.toFixed(0)}
        </Text>
      </TD>
    </TR>
  );
}
